export enum MODULE_STATUS {
    NOT_INITIALIZED = "not_initialized",
    INITIALIZED = "initialized",
}
